export const DATE_FORMAT = "MMMd";
export const DISTANCE = "DISTANCE";
export const EG_RECS_STRATEGY = ["EG_RECS", "EG_RECS_V2"];
export const AFFINITY_DESTINATION_LANDING_PAGE_TYPES = ["Hotel-Filter-Destinations", "Travel-Guide-Filter-Hotels"];
